<c-card *transloco="let t">
    <c-card-body class="px-2">
  
        <c-row>
          <c-col class="col-lg-8 col-12">
            <h1>{{ t('Safety Monitoring Center - 24/7 Emergency Response') }}</h1>
            <p *ngIf="okService.settings.arc_on">{{ t('Your account is setup to use our Safety Monitoring Center with 24/7 Emergency Response from Live Agents.') }}&nbsp;</p>
            <p *ngIf="!okService.settings.arc_on">{{ t('24/7 Emergency Response with Live Agents from our Safety Monitoring Center plan is now available for your account.') }}</p>
          </c-col>

          <c-col class="col-lg-4 col-12 text-end justify-content-end">
            <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/categories/35344534733713-Monitors" role="button" target="_new" *ngIf="okService.settings.arc_on">
              <i class="fa-regular fa-circle-question"></i> {{ t('Monitoring Help') }}
            </a>
            <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/sections/35348755902609-24-7-Safety-Monitoring-Centre" role="button" target="_new" *ngIf="!okService.settings.arc_on">
              <i class="fa-regular fa-circle-question"></i> {{ t('Learn about our Safety Monitoring Center and its 24/7 Emergency Response Capability with Live Agents') }}
            </a>
          </c-col>
        </c-row>
        

        <ul class="nav nav-tabs" *ngIf="okService.settings.arc_on">
        <li class="nav-item" [class.active]="tab=='home'" (click)="tab='home'">
          <a class="nav-link">{{ t('Safety Monitoring Center Home') }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="tab=='validation'" (click)="tab='validation'">
                {{ t('Safety Monitoring Center Validation') }}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="tab=='scheduling'" (click)="tab='scheduling'">
              {{ t('Safety Monitoring Center Scheduling') }}
            </a>
        </li>
        </ul>

          <ng-container *ngIf="tab=='home'">
            <app-monitoring-home></app-monitoring-home>
          </ng-container>

          <ng-container *ngIf="tab=='validation'">
            <app-monitoring-validation></app-monitoring-validation>
          </ng-container>

          <ng-container *ngIf="tab=='scheduling'">
            <app-monitoring-scheduling></app-monitoring-scheduling>
          </ng-container>

    </c-card-body>  
</c-card>   